module.exports = __webpack_public_path__ + "static/base-6-6556581407f8bf92aa6834be2fb423ce.jpg";